import { useTranslation } from "react-i18next";

const OrderSubmitBtn = () =>{
    const { t } = useTranslation("products");
    return(
        <div className="btn_submit_product_sale">
            <button className="order_fulfilment_submit">{t("addNew.submitOrder")} </button>
        </div>
    )
} 
export default OrderSubmitBtn;